// extracted by mini-css-extract-plugin
module.exports = {"separator":"moderationcomment_separator__3Sy5B"};